import { Track } from "livekit-client";
import type { Room } from "livekit-client";
import { SCREEN_SHARE_RPC_TIMEOUT_MS } from "./ScreenShareHandover";
import type { ScreenPublication, ScreenShareTransport } from "./ScreenShareHandover";

export const createLiveKitScreenShareTransport = (room: Room): ScreenShareTransport => ({
    localIdentity: () => room.localParticipant.identity,
    joinedIdentities: () => [room.localParticipant.identity, ...room.remoteParticipants.keys()],
    publications: (): ScreenPublication[] => {
        const publications: ScreenPublication[] = [];
        for (const participant of [room.localParticipant, ...room.remoteParticipants.values()]) {
            for (const publication of participant.trackPublications.values()) {
                // Muted and unsubscribed publications still occupy ownership.
                if (publication.source === Track.Source.ScreenShare) {
                    publications.push({ deviceIdentity: participant.identity, trackSid: publication.trackSid });
                }
            }
        }
        return publications;
    },
    register: (method, handler) => room.registerRpcMethod(method, data => handler(data.callerIdentity, data.payload)),
    unregister: method => room.unregisterRpcMethod(method),
    invoke: (identity, method, payload) => room.localParticipant.performRpc({
        destinationIdentity: identity, method, payload, responseTimeout: SCREEN_SHARE_RPC_TIMEOUT_MS
    })
});
